import { render, staticRenderFns } from "./F10Shareholder.vue?vue&type=template&id=018c61bc"
import script from "./F10Shareholder.vue?vue&type=script&lang=js"
export * from "./F10Shareholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports